import { marker as t } from '@biesbjerg/ngx-translate-extract-marker';

import { AlertEnum } from '@enums/alert.enum';

export interface FlightAlertInfo {
  icon: string;
  title: string;
  oldText: string;
  newText: string;
  hasSegment?: boolean;
}

export interface AlertInfos {
  [AlertEnum.PriceChangeAlert]: FlightAlertInfo;
  [AlertEnum.PassengerNameChangeAlert]: FlightAlertInfo;
  [AlertEnum.PassengerDobChangeAlert]: FlightAlertInfo;
  [AlertEnum.AirlineChangeAlert]: FlightAlertInfo;
  [AlertEnum.FlightNumberChange]: FlightAlertInfo;
  [AlertEnum.DepartureDateTimeChangeAlert]: FlightAlertInfo;
  [AlertEnum.ArrivalDateTimeChangeAlert]: FlightAlertInfo;
  [AlertEnum.BookingClassChangeAlert]: FlightAlertInfo;
  [AlertEnum.CabinClassChangeAlert]: FlightAlertInfo;
  [AlertEnum.BaggageAllowanceChangeAlert]: FlightAlertInfo;
  [AlertEnum.ArrivalAirportChangeAlert]: FlightAlertInfo;
  [AlertEnum.DepartureAirportChangeAlert]: FlightAlertInfo;
}

export class FlightAlertsConstant {
  alertInfos: AlertInfos = {
    [AlertEnum.PriceChangeAlert]: {
      icon: 'mdi mdi-currency-eur',
      title: t('CONFIRMATION.PRICE_CHANGE'),
      oldText: t('CONFIRMATION.OLD_PRICE_CHANGE'),
      newText: t('CONFIRMATION.NEW_PRICE_CHANGE'),
    },
    [AlertEnum.PassengerNameChangeAlert]: {
      icon: 'mdi mdi-priority-high',
      title: t('CONFIRMATION.PASSANGERS_NAME_CHANGE'),
      oldText: t('CONFIRMATION.OLD_PASSANGERS_NAME_CHANGE'),
      newText: t('CONFIRMATION.NEW_PASSANGERS_NAME_CHANGE'),
    },
    [AlertEnum.PassengerDobChangeAlert]: {
      icon: 'mdi mdi-priority-high',
      title: t('CONFIRMATION.PASSENGER_BIRTHDAY_CHANGE'),
      oldText: t('CONFIRMATION.OLD_PASSENGER_BIRTHDAY_CHANGE'),
      newText: t('CONFIRMATION.NEW_PASSENGER_BIRTHDAY_CHANGE'),
    },
    [AlertEnum.AirlineChangeAlert]: {
      icon: 'mdi mdi-airplane',
      title: t('CONFIRMATION.AIRLINE_BIRTHDAY_CHANGE'),
      oldText: t('CONFIRMATION.OLD_AIRLINE_BIRTHDAY_CHANGE'),
      newText: t('CONFIRMATION.NEW_AIRLINE_BIRTHDAY_CHANGE'),
      hasSegment: true,
    },
    [AlertEnum.FlightNumberChange]: {
      icon: 'mdi mdi-airplane',
      title: t('CONFIRMATION.FLIGHT_NUMBER_BIRTHDAY_CHANGE'),
      oldText: t('CONFIRMATION.OLD_FLIGHT_NUMBER_BIRTHDAY_CHANGE'),
      newText: t('CONFIRMATION.NEW_FLIGHT_NUMBER_BIRTHDAY_CHANGE'),
      hasSegment: true,
    },
    [AlertEnum.DepartureDateTimeChangeAlert]: {
      icon: 'mdi mdi-airplane-takeoff',
      title: t('CONFIRMATION.DEPARTURE_TIME_CHANGE'),
      oldText: t('CONFIRMATION.OLD_DEPARTURE_TIME_CHANGE'),
      newText: t('CONFIRMATION.NEW_DEPARTURE_TIME_CHANGE'),
      hasSegment: true,
    },
    [AlertEnum.ArrivalDateTimeChangeAlert]: {
      icon: 'mdi mdi-airplane-landing',
      title: t('CONFIRMATION.ARRIVAL_TIME_CHANGE'),
      oldText: t('CONFIRMATION.OLD_ARRIVAL_TIME_CHANGE'),
      newText: t('CONFIRMATION.NEW_ARRIVAL_TIME_CHANGE'),
      hasSegment: true,
    },
    [AlertEnum.BookingClassChangeAlert]: {
      icon: 'mdi mdi-seat-legroom-extra',
      title: t('CONFIRMATION.BOOKING_CLASS_CHANGE'),
      oldText: t('CONFIRMATION.OLD_BOOKING_CLASS_CHANGE'),
      newText: t('CONFIRMATION.NEW_BOOKING_CLASS_CHANGE'),
      hasSegment: true,
    },
    [AlertEnum.CabinClassChangeAlert]: {
      icon: 'mdi mdi-seat-recline-normal',
      title: t('CONFIRMATION.CABIN_CLASS_CHANGE'),
      oldText: t('CONFIRMATION.OLD_CABIN_CLASS_CHANGE'),
      newText: t('CONFIRMATION.NEW_CABIN_CLASS_CHANGE'),
      hasSegment: true,
    },
    [AlertEnum.BaggageAllowanceChangeAlert]: {
      icon: 'mdi mdi-bag-carry-on',
      title: t('CONFIRMATION.BAGGAGE_CLASS_CHANGE'),
      oldText: t('CONFIRMATION.OLD_BAGGAGE_CLASS_CHANGE'),
      newText: t('CONFIRMATION.NEW_BAGGAGE_CLASS_CHANGE'),
      hasSegment: true,
    },
    [AlertEnum.ArrivalAirportChangeAlert]: {
      icon: 'mdi mdi-airport',
      title: t('CONFIRMATION.ARRIVAL_AIRPORT_CLASS_CHANGE'),
      oldText: t('CONFIRMATION.OLD_ARRIVAL_AIRPORT_CLASS_CHANGE'),
      newText: t('CONFIRMATION.NEW_ARRIVAL_AIRPORT_CLASS_CHANGE'),
      hasSegment: true,
    },
    [AlertEnum.DepartureAirportChangeAlert]: {
      icon: 'mdi mdi-airport',
      title: t('CONFIRMATION.DEPARTURE_AIRPORT_CLASS_CHANGE'),
      oldText: t('CONFIRMATION.OLD_DEPARTURE_AIRPORT_CLASS_CHANGE'),
      newText: t('CONFIRMATION.NEW_DEPARTURE_AIRPORT_CLASS_CHANGE'),
      hasSegment: true,
    },
  };
}
